import { AssetLocation } from "../model/Picture";

export enum SocialTypeId {
  LINKEDIN = "LINKEDIN",
  FACEBOOK = "FACEBOOK",
  YOUTUBE = "YOUTUBE",
  INSTAGRAM = "INSTAGRAM",
  GITHUB = "GITHUB",
  MEDIUM = "MEDIUM",
  TWITTER = "TWITTER",
  STACKOVERFLOW = "STACKOVERFLOW",
  BLOG = "BLOG",
  GLASSDOOR = "GLASSDOOR",
  WEBSITE = "WEBSITE",
  OTHER = "OTHER",
}

export interface SocialType {
  id: SocialTypeId;
  dl: string;
  dp: AssetLocation;
  domains: string[];
}

export interface SocialLink {
  type: SocialType;
  url: string;
}
